import { render, staticRenderFns } from "./QuestionCheckbox.vue?vue&type=template&id=f2ecc5b6&scoped=true&"
import script from "./QuestionCheckbox.vue?vue&type=script&lang=js&"
export * from "./QuestionCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCheckbox.vue?vue&type=style&index=0&id=f2ecc5b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ecc5b6",
  null
  
)

export default component.exports